module.exports = __webpack_public_path__ + "img/s_07.5763dfaf.png";